export interface TaxSlab {
  id: string
  financialYear: FinancialYear
  regime: Regime
  lowerLimit: number
  upperLimit: number | null
  ratePercent: number
}

export enum Regime {
  NEW = 'New',
  OLD = 'Old'
}

export enum RuleCode {
  STD_DEDUCTION = 'STD_DEDUCTION',
  REBATE_87A_INCOME_LIMIT = 'REBATE_87A_INCOME_LIMIT',
  REBATE_87A_MAX_AMOUNT = 'REBATE_87A_MAX_AMOUNT',
  CESS_RATE = 'CESS_RATE'
}

export interface TaxRule {
  ruleName: string | null
  ruleCode: RuleCode
  ruleValue: number
  description: string | null
  regime: Regime
}

export interface TaxSettings extends FinancialYear {
  taxRules: TaxRule[]
  taxSlabs: TaxSlab[]
}

export interface FinancialYear {
  id: string
  name: string
  startDate: string
  endDate: string
}

export interface TaxSettingsState {
  financialYears: FinancialYear[]
  fyTaxSettings: TaxSettings | null
  loading: boolean
  error: string | null
}

export const initialState: TaxSettingsState = {
  financialYears: [],
  fyTaxSettings: null,
  loading: false,
  error: null
}
